import { VmtTree } from "./VmtTree";

export default VmtTree;